module.exports = __webpack_public_path__ + "img/img10.89ead7ef.png";